// extracted by mini-css-extract-plugin
export default {"root":"_2b6Y6","label":"vz3j6","value":"_3WzkN"};